export class Golf {
    id: number;
    name: string;
    name_short: string;
    bgcolor: string;
    work_kbn: string;
    user_id: number;
    active: string;
    user_flg: string;
    modified: string;
    constructor(){
        this.id = 0;
        this.name = '';
        this.name_short = '';
        this.bgcolor = '#ffffff';
        this.work_kbn = '1';
        this.user_id = 0;
        this.active = '1';
        this.user_flg = '0';
    }
}
export class GolfUser extends Golf {
    username: string;
    password: string;
    userinfo_id: number;
    email: string;
    token: string;
    constructor(){
        super();
        this.username = '';
        this.password = '';
        this.userinfo_id = 0;
        this.email = '';
        this.token = '';
    }
}
